import React from 'react';
import Flag from '@atlaskit/flag';
import EditorInfoIcon from '@atlaskit/icon/glyph/editor/info';
import { translate } from '../../../base/i18n';
import { Notification } from './Notification';

class RPC_Notification extends Notification {
    render() {
        const {
            appearance,
            hideErrorSupportLink,
            t,
            title,
            titleArguments,
            titleKey,
            uid
        } = this.props;
        
        let _title = title;
        if(titleArguments && titleArguments.name) {
            _title = titleArguments.name;
        }
        
        return (
            <Flag
                actions = { this._mapAppearanceToButtons(hideErrorSupportLink) }
                appearance = { appearance }
                description = { this._renderDescription() }
                icon = { this._mapAppearanceToIcon(_title, this._getDescription().length) }
                id = { uid }
                testId = { titleKey }
                title = { title || t(titleKey, titleArguments) } />
        );
    }
    _mapAppearanceToIcon(text, haveDescription) {
        const appearance = 'info';
        const secIconColor = '#42526E';
        const iconSize = 'medium';

        if ( text && haveDescription ) { return <div className="notification_logo">{ text.slice(0,1) }</div> }

        return (
            <EditorInfoIcon
                label = { appearance }
                secondaryColor = { secIconColor }
                size = { iconSize } />
        );
    }
}

export default translate(RPC_Notification);